import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';

// Renders the official "Sign in with Google" button (Google Identity Services).
// Hidden when the backend has no GOOGLE_CLIENT_ID configured.
let gsiPromise = null;
const loadGsi = () => {
  if (!gsiPromise) {
    gsiPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://accounts.google.com/gsi/client';
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return gsiPromise;
};

export default function GoogleButton({ onCredential, text = 'signin_with' }) {
  const ref = useRef(null);
  const cbRef = useRef(onCredential);
  const [enabled, setEnabled] = useState(false);
  cbRef.current = onCredential;

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/referral/auth/google/config');
        if (!data.client_id || cancelled) return;
        await loadGsi();
        if (cancelled || !ref.current) return;
        window.google.accounts.id.initialize({
          client_id: data.client_id,
          callback: resp => cbRef.current(resp.credential),
        });
        window.google.accounts.id.renderButton(ref.current, {
          theme: 'outline', size: 'large', text, shape: 'pill',
          width: Math.min(ref.current.offsetWidth || 340, 400),
        });
        setEnabled(true);
      } catch (e) {
        // Google sign-in unavailable — leave the button hidden
      }
    })();
    return () => { cancelled = true; };
  }, [text]);

  return (
    <div style={{ display: enabled ? 'block' : 'none' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.25rem 0 1rem', color: '#94a3b8', fontSize: '.8rem' }}>
        <div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />or<div style={{ flex: 1, height: 1, background: '#e2e8f0' }} />
      </div>
      <div ref={ref} style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem', width: '100%' }} />
    </div>
  );
}
